import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateExtendedWarrantyPurchasedCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ExtendedWarrantyPurchasedState = void;

export const EXTENDED_WARRANTY_PURCHASED = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ExtendedWarrantyPurchasedState>
  >,
): ConditionType<
  ExtendedWarrantyPurchasedState,
  Condition.ExtendedWarrantyPurchased
> => ({
  name: CONDITION_NAMES[Condition.EXTENDED_WARRANTY_PURCHASED],
  description() {
    return t("Extended warranty purchased");
  },
  Details(props: ConditionTypeDetailsProps<ExtendedWarrantyPurchasedState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.EXTENDED_WARRANTY_PURCHASED };
  },
  valid() {
    return validateExtendedWarrantyPurchasedCondition({}).valid;
  },
});
